// extracted by mini-css-extract-plugin
export default {"root":"CategoryHeader-module__root","backButton":"CategoryHeader-module__backButton","backIcon":"CategoryHeader-module__backIcon","title":"CategoryHeader-module__title"};